<template>
  <v-row>
    <v-col cols="12" md="6" lg="4" offset-md="3" offset-lg="4">
      <v-card class="elevation-12">
        <v-card-text class="text-center">
          <v-btn text block class="green darken-4" rounded dark :to="{name: 'web-client-import'}">Импорт нового
            реестра
          </v-btn>
          <v-btn text block class="green darken-4 mt-1" rounded dark :to="{name: 'web-client-registries'}">Реестры
          </v-btn>
          <v-btn text block class="green darken-4 mt-1" rounded dark :to="{name: 'web-client-report'}">Отчёты</v-btn>
          <v-btn text block class="red darken-4 mt-1" rounded dark @click="onLogoutClicked">Выход</v-btn>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import {AUTH_LOGOUT} from "@/store/modules/auth/actions";

export default {
  name: "Dashboard",
  methods: {
    onLogoutClicked() {
      this.$store.dispatch(AUTH_LOGOUT)
    }
  }
}
</script>

<style scoped>

</style>